/**
 * Runtime environment detection based on hostname.
 * No build-time env vars needed — works for both test and prod deployments.
 */
const isTest = window.location.hostname.startsWith('test-') || window.location.hostname.startsWith('test.');

export const APP_URL = isTest
  ? 'https://test-app.prettifai-robot.com'
  : 'https://app.prettifai-robot.com';

export const API_URL = isTest
  ? 'https://test-api.prettifai-robot.com'
  : 'https://api.prettifai-robot.com';
